<template>
  <el-dialog :title="title"
             :visible.sync="params.flag"
             v-dialogDrag
             :modal="false"
             :close-on-click-modal="false"
             :lock-scroll="false"
             :modal-append-to-body=false
             :append-to-body="false"
             ref="jsfxRef"
             width="50%"
             custom-class="wtlp"
  >
    <div slot="title" class="select-header">
      <span>{{title}}</span>
      <span>
          <span v-if="shuiWenStationSlideResult && shuiWenStationSlideResult.liveMap && shuiWenStationSlideResult.liveMap.ddatetime" class="update-time">
            更新时间：{{
              $moment(shuiWenStationSlideResult.liveMap.ddatetime * 1000).format("YYYY-MM-DD HH:mm")
            }}
          </span>
        </span>
    </div>
    <div class="main">
      <div class="content">
        <div class="water-temperature-live">
          <div class="water-temperature-live-wrap">
            <div class="water-temperature-live-list" ref="hourForecastList">
              <div class="chart" :id="chartId"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import 'echarts/lib/component/markLine'
import echarts from '@/config/echarts'
import Vue from 'vue'
import { getSlideLiveOption, getZjzSlideLiveOption } from '@/config/echarts/option/point-slide-live'
import { mapState } from 'vuex'
import { getLiveOption } from '@/config/echarts/option/water-temperature-live'

export default {
  components: { },
  props: ['params', 'forecastType', 'cardEchart'],
  data () {
    return {
      rootFontSize: window.rootFontSize,
      chartId: '',
      charts: '',
      data: {}
    }
  },
  watch: {
    'params.flag': {
      handler (flag) {
        if (flag) {
          this.setZindex()
          this.resetEchart()
        }
      },
      immediate: true
    },
    shuiWenStationSlideResult: {
      handler () {
        this.$nextTick(() => {
          this.getData()
        })
      },
      deep: true
    },
    activeCountyId: {
      handler () {
        setTimeout(() => {
          this.$nextTick(() => {
            this.getData()
          })
        }, 100)
      },
      immediate: true
    }
  },
  created () {
    this.chartId = 'water-temperature-live-chart' + new Date().getTime()
    console.log('this.chartId', this.chartId)
  },
  computed: {
    ...mapState('home', ['objsList', 'activeCountyId', 'shuiWenStationSlideResult']),
    title () {
      return '过去24小时水温'
    }
  },
  mounted () {
    this.setZindex()
  },
  methods: {
    // 设置弹出框的zIndex
    setZindex () {
      this.$nextTick(() => {
        const el = this.$refs.jsfxRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    },
    initEchart () {
      const idName = this.chartId
      const tempChart = echarts.init(document.getElementById(idName))
      tempChart.setOption(getLiveOption())
      this.charts = tempChart
      // 页面缩放
      window.onresize = () => {
        Vue.prototype.$rootFontSize = document.body.clientWidth / 1920 * 16
        document.getElementsByTagName('html')[0].style.fontSize = this.$rootFontSize + 'px'
        this.charts.resize()
      }
    },
    async getData () {
      const shuiWenStationSlideResult = this.shuiWenStationSlideResult
      if (!shuiWenStationSlideResult.times) {
        return
      }
      this.data = shuiWenStationSlideResult
      if (!this.charts) {
        this.initEchart()
      }
      const times = shuiWenStationSlideResult.times.map(v => v * 1000)
      const option1 = getLiveOption()
      option1.xAxis.data = times
      option1.series[0].data = shuiWenStationSlideResult.temp0
      option1.series[1].data = shuiWenStationSlideResult.temp1
      option1.series[2].data = shuiWenStationSlideResult.temp2
      option1.series[3].data = shuiWenStationSlideResult.temp3
      const temp = [...shuiWenStationSlideResult.temp0, ...shuiWenStationSlideResult.temp1, ...shuiWenStationSlideResult.temp2, ...shuiWenStationSlideResult.temp3]
      option1.yAxis[0].max = Math.floor(Math.max(...temp) + 2)
      option1.yAxis[0].min = Math.floor(Math.min(...temp) - 2)
      this.charts.clear()
      this.charts.setOption(option1)
      this.$nextTick(() => {
        this.charts.resize()
      })
      this.$nextTick(() => {
        this.charts.resize()
      })
    },
    resetEchart () {
      this.$nextTick(() => {
        this.charts && this.charts.resize()
      })
    }
  }
}
</script>
<style lang="less" scoped>

.select-header {
  display: flex;
  justify-content: space-between;
  padding-right: 2.6vw;
  color: #fff;

  span:nth-child(1) {
    font-size: 0.94vw;
    font-weight: 600;
    color: #fff;
  }

  span:nth-child(2) {
    font-size: 0.73vw;
  }
}

/deep/ .el-dialog__wrapper {
  overflow: hidden;

  .el-dialog {
    pointer-events: auto;
  }
}

.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;
  width: 100%;
  height: 100%;
  //height: 30vh;

  .water-temperature-live {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0vw;

    .water-temperature-live-wrap {
      position: relative;
      // top: -2.04vw;
      width: 100%;
      margin-top: 0.52vw;
      height: calc(100% - 0.52vw);
      overflow: hidden;

      .water-temperature-live-list {
        width: 100% !important;
        display: flex;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        transition: all 0.3s linear;

        .item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          width: 5.58rem;

          span {
            font-size: 0.75rem;
            color: #FFF;
          }

          .des {
            font-size: 0.88rem;
            color: #FFF;
          }

          img {
            width: 2.25rem;
          }

          .chart {
            height: 90%;
          }

          .wind {
            color: #FFF;
          }
        }

        .chart {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
        }
      }
    }
  }
  .publish-time {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2.08vw;
    top: .8vw;;
    color: #FFF;
    font-size: 0.63vw;

    .el-icon-time {
      margin-right: 0.26vw;
    }
  }
}

</style>
